export default "__VITE_ASSET__9f00056b__"